export default __webpack_public_path__ + "static/media/Ok-pana 1.cf429424.png";